import { ReactNode, useMemo } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import routes from 'routes';
import { filterRoutes, firstRoute, allowedScreens, isKnownRoute } from 'functions/allowed-routes';
import { NoPermission } from 'layouts/authentication/no-permission';
import { NotFound } from 'layouts/authentication/not-found';
import { AppRoute } from 'types/app-route';

/// A raiz e o /home do logo do menu não são telas: levam para a primeira liberada.
const HOME_PATHS = ['/', '/home'];

const Fallback = ({ destination }: { destination: string | null }) => {
    const { pathname } = useLocation();

    // Sem tela liberada não há destino; redirecionar a rota inexistente deixa o conteúdo em branco.
    if (!destination) return <NoPermission />;

    if (HOME_PATHS.includes(pathname) || isKnownRoute(routes, pathname)) {
        return <Navigate to={destination} replace />;
    }

    return <NotFound home={destination} />;
};

const getRoutes = (allRoutes: AppRoute[]): ReactNode[] =>
    allRoutes.map((route) => {
        if (route.collapse) return getRoutes(route.collapse);

        if (route.route)
            return <Route path={route.route} element={route.component} key={route.key} />;

        return null;
    });

export default function RoutesApp() {
    // Só esconder no menu não basta: sem filtrar aqui, digitar o endereço ainda abriria a tela.
    const allowed = useMemo(() => filterRoutes(routes, allowedScreens()), []);
    const destination = useMemo(() => firstRoute(allowed), [allowed]);

    return (
        <Routes>
            {getRoutes(allowed)}

            <Route path="*" element={<Fallback destination={destination} />} />
        </Routes>
    );
}
